export default __webpack_public_path__ + "68aa71f4a2b837db5ad3fd89181aba35.ttf";